module.exports = __webpack_public_path__ + "static/media/ineuron-logo (1).fe835e4f.png";